import styled from "styled-components";
//interfaces
import { IMessageBox } from "./interface";

export const MessageBoxContainer = styled.div<IMessageBox>`
  display: flex;
  width: 420px;
  background-color: ${(props) => props.backgroundColor};
  border-left: 1px solid ${(props) => props.borderColor};
  border-right: 1px solid ${(props) => props.borderColor};
  border-bottom: 1px solid ${(props) => props.borderColor};
  border-top: 1px solid ${(props) => props.borderColor};
  border-radius: 4px;
  align-items: center;

  @media screen and (max-width: 665px) {
    width: 100%;
  }
`;

export const MessageBoxContent = styled.div<IMessageBox>`
  padding: 4px 8px;

  h1, p {
    font-size: 14px;
  }

  h1 {
    color: ${(props) => props.color};
    font-weight: 900;
  }

  p {
    color: ${(props) => props.color};
    line-height: 16.8px;
  }
`

export const MessageBoxIconDiv = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
  min-width: 16px;
`